import { memo, ReactNode } from 'react';
import { Box, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_TOKENS } from '../constants';
import BuilderModeSvgIcon from '../icons/BuilderModeSvgIcon';

import outlineActionButtonStyles from './outlineActionButtonStyles';

export interface OutlineActionButtonProperties {
  label: string;
  leftIcon?: ReactNode;
  rightSlot?: ReactNode;
  minW?: string | number;
  w?: string | number;
  onClick?: () => void;
  'aria-label'?: string;
}

const OutlineActionButton = memo(
  ({
    label,
    leftIcon,
    rightSlot,
    minW,
    w,
    onClick,
    'aria-label': ariaLabel,
  }: OutlineActionButtonProperties) => (
    <Box
      as='button'
      type='button'
      aria-label={ariaLabel ?? label}
      onClick={onClick}
      minW={minW}
      w={w}
      sx={outlineActionButtonStyles}
    >
      {leftIcon}
      <Text
        flex='1'
        minW={0}
        fontSize='14px'
        fontWeight='400'
        color={BUILDER_MODE_V1_TOKENS.textDark}
        lineHeight='normal'
        textAlign='left'
        noOfLines={1}
      >
        {label}
      </Text>
      {rightSlot ?? <BuilderModeSvgIcon name='chevronDown' />}
    </Box>
  ),
);

OutlineActionButton.displayName = 'OutlineActionButton';

export default OutlineActionButton;
